import { List } from 'immutable';

import { ENUM_IDENTITY_STATUS, IDENTITY_TYPE } from 'enum/profile';
import { Identity } from 'services/IdentitiesService';
import { ImmutableMap } from 'utils/typeHelpers';


type ImmutableIdentity = ImmutableMap<Identity>;

export function isInStatus(identity: ImmutableIdentity, status: string): boolean {
  return identity.get('status') === status;
}

export function areAllIdentitiesApproved(identities: Array<ImmutableIdentity>): boolean {
  return identities.every((item) => isInStatus(item, ENUM_IDENTITY_STATUS.APPROVED));
}

export function isMainIdentity(identity: ImmutableIdentity): boolean {
  return identity.get('identityType') === IDENTITY_TYPE.MAIN;
}

export function areAllSecondaryIdentitiesApproved(identities: List<ImmutableIdentity>): boolean {
  const secondaryIdentities = identities.filter((item) => !isMainIdentity(item));

  if (secondaryIdentities.size === 0) {
    return true;
  }

  return secondaryIdentities.every(
    (item) => isInStatus(item, ENUM_IDENTITY_STATUS.APPROVED)
  );
}

export function hasUnapprovedSecondaryIdentity(identities: Array<ImmutableIdentity>): boolean {
  return identities.some((item) => !isMainIdentity(item) && !isInStatus(item, ENUM_IDENTITY_STATUS.APPROVED));
}

